let SEC = require('common/js/utils/core.js');

//批量设置cookies
export function setCookies(setCookie, obj, max_age, domain){
    for(let attr in obj){
        setCookie({
            name: attr,
            value: obj[attr],
            expires: max_age,
            domain: domain
        });
    }
}

//返回location.search
export function getLocationSearch(){
    let search    = location.search,
        hash      = location.hash,
        que_index = hash.indexOf('?');

    if(!search && que_index !== -1){
        search = hash.slice(que_index);
    }
    return search;
}

// 根据是否支持图片模式webp，计算图片地址
export function getImgSrcByIsWebpSupport (src, index, imgSize = false) {
    let webpSuffix = '_!!0x0.webp';
    let reg = /^(https?:)?\/\/pic(\d)+.secooimg.com\//;
    let isSupport = reg.test(src) || !/^(https?:)?\/\//.test(src);

    if (!this.isWebpSupport) {
       src = src.replace(webpSuffix, '');
    } else {
        if (isSupport && !/\.webp$/.test(src)) {
            src += webpSuffix;
        }
    }

    if (isSupport) {
        // 修复pic13、pic14域名不可用问题
        let picIndex = index % 10 + 10;
        switch (picIndex) {
            case 13:
            case 14:
                picIndex = 16;
                break;
        }

        return '//pic' + picIndex +'.secooimg.com/' + (imgSize ? `product/${ imgSize }/${ imgSize }/` : '') + src.replace(reg, '').replace(/^\//, '');
    }

    return src;
}



// WEBPACK FOOTER //
// ./src/public/js/public.js